(function () {
    var msDateRE = /^\/Date\((\d+)\)\/$/;

    angular.module('st')
        .filter('format', function () {
            return function (formatStr, items) {
                if (!items || !items.length) {
                    return formatStr;
                }
                return items.reduce(function (formatted, item, i) {
                    return formatted.replace(new RegExp('\\{' + i + '\\}'), item);
                }, formatStr);
            };
        })
        .filter('msDate', ['$filter', function ($filter) {
            return function (input, format, timezone) {
                var ms;
                if (input && (ms = input.match(msDateRE))) {
                    return $filter('date')(ms[1], format, timezone);
                }
                return $filter('date')(input, format, timezone);
            };
        }])
        .config(['$locationProvider', function ($locationProvider) {
            $locationProvider.html5Mode({
                enabled: true,
                requireBase: false,
                rewriteLinks: false
            });
        }]);
    // add any custom modules used in this project in the array below
    //angular.bootstrap(document.body, modules);
})();